module.exports = __webpack_public_path__ + "static/media/25.d0f81b2e.jpg";